var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('head-nav'),_c('main',{staticClass:"pt-24 px-16"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }